import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { DataUser, RolesUser } from '../../shared/models/users.model';
import { LocalStorageService } from '../../shared/services/local-storage.service';

@Injectable({
	providedIn: 'root',
})
export class ConsultantGuard {
	user!: DataUser;

	constructor(
		private router: Router,
		public localStorage: LocalStorageService,
		@Inject(PLATFORM_ID) private platformId: Object
	) {}

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		if (isPlatformServer(this.platformId)) {
			return true;
		}
		const localUser = this.localStorage.getItem('ROD-logged.user');
		if (localUser != null) {
			this.user = JSON.parse(localUser);
		}
		if (this.user?.authContext?.role === RolesUser.CONSULTANT) {
			return true;
		} else {
			this.router.navigate(['/']);
			return false;
		}
	}
}
